"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiantSavETHPoolSubPackage = void 0;
const giantSavETHPool_1 = require("../logic/giantSavETHPool");
class GiantSavETHPoolSubPackage {
    constructor(signer) {
        this.etherSigner = signer;
    }
    batchDepositETHForStaking(savETHVaultAddresses, amounts, blsPublicKeys, stakeAmounts) {
        return (0, giantSavETHPool_1._batchDepositETHForStaking)(this.etherSigner, savETHVaultAddresses, amounts, blsPublicKeys, stakeAmounts);
    }
    withdrawDETH(savETHVaultAddresses, lpTokens, amounts) {
        return (0, giantSavETHPool_1._withdrawDETH)(this.etherSigner, savETHVaultAddresses, lpTokens, amounts);
    }
    bringUnusedETHBackIntoGiantPool(savETHVaultAddresses, lpTokens, amounts) {
        return (0, giantSavETHPool_1._bringUnusedETHBackIntoGiantPool)(this.etherSigner, savETHVaultAddresses, lpTokens, amounts);
    }
    depositETH(amount, ethValue) {
        return (0, giantSavETHPool_1._depositETH)(this.etherSigner, amount, ethValue);
    }
    getIdleETH() {
        return (0, giantSavETHPool_1._getIdleETH)(this.etherSigner);
    }
    withdrawETH(amount) {
        return (0, giantSavETHPool_1._withdrawETH)(this.etherSigner, amount);
    }
    batchPartialWithdrawal(savETHVaultAddresses, lpTokens, amounts) {
        return (0, giantSavETHPool_1._batchPartialWithdrawal)(this.etherSigner, savETHVaultAddresses, lpTokens, amounts);
    }
    batchFetchETHFromRageQuit(savETHVaultAddresses, lpTokens, amounts) {
        return (0, giantSavETHPool_1._batchFetchETHFromRageQuit)(this.etherSigner, savETHVaultAddresses, lpTokens, amounts);
    }
    fetchETHFromRageQuit(savETHVaultAddress, lpToken, amount) {
        return (0, giantSavETHPool_1._fetchETHFromRageQuit)(this.etherSigner, savETHVaultAddress, lpToken, amount);
    }
    batchClaimETHFromRageQuit(blsPublicKeys) {
        return (0, giantSavETHPool_1._batchClaimETHFromRageQuit)(this.etherSigner, blsPublicKeys);
    }
    claimETHFromRageQuit(blsPublicKey) {
        return (0, giantSavETHPool_1._claimETHFromRageQuit)(this.etherSigner, blsPublicKey);
    }
}
exports.GiantSavETHPoolSubPackage = GiantSavETHPoolSubPackage;
